module.exports = __webpack_public_path__ + "img/m_footer.acc02f67.png";